import React from 'react';
import classNames from 'classnames';
import styles from './Badge.module.css';

export type BadgeVariant = 'good' | 'bad' | 'info' | 'neutral';

interface BadgeProps {
  variant: BadgeVariant;
  children?: React.ReactNode;
  showIcon?: boolean;
  className?: string;
}

const BadgeIcon: React.FC<{ variant: BadgeVariant }> = ({ variant }) => {
  switch (variant) {
    case 'good':
      return (
        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
          <polyline
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="4 8 7 11 12 5"
          />
        </svg>
      );
    case 'bad':
      return (
        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
          <line x1="8" y1="4" x2="8" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <circle cx="8" cy="12" r="1" fill="currentColor" />
        </svg>
      );
    case 'info':
    case 'neutral':
      return (
        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="4" r="1" fill="currentColor" />
          <line x1="8" y1="7" x2="8" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
  }
};

export const Badge: React.FC<BadgeProps> = ({ variant, children, showIcon = true, className }) => {
  return (
    <span className={classNames(styles.badge, styles[variant], className)}>
      {showIcon && (
        <span className={styles.iconWrapper}>
          <BadgeIcon variant={variant} />
        </span>
      )}
      {children && <span className={styles.label}>{children}</span>}
    </span>
  );
};
